// assets
import hwStatsLogo from '../../../assets/common/HW_stats 1.png';
import mobileMenuButton_img from '../../../assets/common/mobile-menu-button.svg';

// code imports
import { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import HeaderMenu from './HeaderMenu';
import { Link } from 'react-router-dom';

function Mobile_Header({ style, links, isSticky, onLogout, page, ...otherProps }) {
    const [openMenu, setOpenMenu] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const HEADER_H = page === 'hitstats' ? 88 : 72; // tighter + modern

    const closeMenu = () => {
        setIsAnimating(true);
        setTimeout(() => {
            setOpenMenu(false);
            setIsAnimating(false);
        }, 250);
    };

    // Close on Escape
    useEffect(() => {
        if (!openMenu) return;
        const onKey = (e) => e.key === 'Escape' && closeMenu();
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openMenu]);

    // Lock body scroll when menu is open
    useEffect(() => {
        if (!openMenu) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = prev;
        };
    }, [openMenu]);

    const logoSrc = page === 'hitstats' ? hwStatsLogo : "https://cdn.octathorpeweb.com/v1/website/sachinxhw/hitwicket-logo.png";
    const homeHref = page === 'hitstats' ? '/hitstats/team' : '/';

    const styles = useMemo(
        () => ({
            background: 'transparent',
            backdropFilter: isSticky ? 'blur(10px)' : "none",
            WebkitBackdropFilter: isSticky ? "blur(10px)" : "none",
            borderBottom: isSticky ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(255,255,255,0)",
            height: `${HEADER_H}px`,
            position: isSticky ? 'sticky' : 'absolute',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            ...style,
        }),
        [HEADER_H, isSticky, style]
    );


    return (
        <div {...otherProps} className="Header d-flex align-items-center px-3" style={styles}>
            {/* Left: Logo */}
            <div className="d-flex align-items-center" style={{ flex: 1, minWidth: 0 }}>
                <Link to={homeHref} style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
                    <img
                        src={logoSrc}
                        alt="Hitwicket"
                        style={{
                            height: page === 'hitstats' ? 48 : 54,
                            width: 'auto',
                            objectFit: 'contain',
                            display: 'block',
                        }}
                    />
                </Link>
            </div>

            {/* Right: Menu Button */}
            <button
                type="button"
                aria-label="Open menu"
                onClick={() => (openMenu ? closeMenu() : setOpenMenu(true))}
                style={{
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    border: '1px solid rgba(255,255,255,0.12)',
                    background: 'rgba(255,255,255,0.06)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    padding: 0,
                }}
            >
                <img
                    src={mobileMenuButton_img}
                    alt=""
                    style={{ width: 22, height: 22, objectFit: 'contain', opacity: 0.95 }}
                />
            </button>

            {/* Full-screen menu, rendered in <body> so the sticky header's blur can't trap its fixed positioning */}
            {openMenu && createPortal(
                <div
                    className={`mobile-menu-container ${isAnimating ? 'slide-out-up' : 'slide-in-down'}`}
                    role="dialog"
                    aria-modal="true"
                    aria-label="Menu"
                    style={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 1000002,
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        background: '#140833',
                    }}
                >
                    <div
                        className="d-flex align-items-center px-3"
                        style={{ flex: '0 0 auto', height: `${HEADER_H}px` }}
                    >
                        <div style={{ flex: 1 }}>
                            <Link to={homeHref} onClick={closeMenu} style={{ display: 'inline-flex' }}>
                                <img src={logoSrc} alt="Hitwicket" style={{ height: page === 'hitstats' ? 48 : 54, width: 'auto', objectFit: 'contain' }} />
                            </Link>
                        </div>
                        <button
                            type="button"
                            aria-label="Close menu"
                            onClick={closeMenu}
                            style={{
                                width: 44,
                                height: 44,
                                borderRadius: 12,
                                border: '1px solid rgba(255,255,255,0.25)',
                                background: 'transparent',
                                color: '#fff',
                                fontSize: 28,
                                lineHeight: 1,
                                padding: 0,
                            }}
                        >
                            &times;
                        </button>
                    </div>
                    <HeaderMenu
                        links={links}
                        device="mobile"
                        onMenuItemClick={(label) => {
                            closeMenu();
                            if (label === 'LOGOUT' && onLogout) {
                                setTimeout(() => onLogout(), 300);
                            }
                        }}
                    />
                </div>,
                document.body
            )}
        </div>
    );
}

export default Mobile_Header;
